/* Fußzeile: Menüblöcke auf dem Telefon zugeklappt.

   Warum es diese Datei überhaupt gibt – es ist die einzige Stelle im ganzen
   mobilen Umbau, an der neues JavaScript für reine Darstellung dazukommt:
   Ein <details> lässt sich per CSS nicht zuverlässig aufzwingen. `open` ist
   ein Attribut, kein Stil; es gibt keine Eigenschaft, die es ab 640 px wieder
   setzt. Der Ausweg wäre ein Höhenübergang mit versteckter Checkbox – und
   damit läge die Tastatur- und Vorlesebedienung wieder bei uns statt beim
   Browser.

   Die Richtung ist bewusst gewählt: Das Markup rendert MIT `open`, dieses
   Skript nimmt es unterhalb der Schwelle weg. Bleibt das Skript aus (Fehler,
   blockiert, altes Gerät), steht die Fußzeile aufgeklappt da – länger als
   nötig, aber vollständig bedienbar. Andersherum wäre der Ausfall eine
   Fußzeile ohne Links.

   Die Schwelle kommt aus --bp-s in :root, damit CSS und Skript dieselbe Zahl
   benutzen und nicht auseinanderlaufen – dieselbe Begründung wie bei --bp-nav
   und der Menü-Schublade. */
(function () {
  var roh = getComputedStyle(document.documentElement).getPropertyValue('--bp-s');
  var px = parseInt(String(roh).trim(), 10);
  if (isNaN(px)) px = 640;                  // Token fehlt: Leiterwert von Hand
  var mq = window.matchMedia('(min-width: ' + px + 'px)');

  /* Nur beim Wechsel der Schwelle, nicht bei jeder Größenänderung: sonst
     schnappt ein Block, den jemand gerade geöffnet hat, beim Drehen des
     Geräts wieder zu. */
  function nachziehen() {
    var bloecke = document.querySelectorAll('.footer__block');
    for (var i = 0; i < bloecke.length; i++) bloecke[i].open = mq.matches;
  }

  nachziehen();
  if (mq.addEventListener) mq.addEventListener('change', nachziehen);
  else if (mq.addListener) mq.addListener(nachziehen);   // Safari vor 14
})();
